export default __webpack_public_path__ + "static/media/img-logo_white.fbf30b78.svg";